import { ForwardRefExoticComponent, RefAttributes } from 'react';
import {
  ArrowRightSquare,
  Link,
  Gem,
  User,
  Users,
  KeyRound,
  Pickaxe,
  Handshake,
  IdCard,
  Signature,
  LucideProps,
} from 'lucide-react';

import { TaskKey } from '@app/store/slices/tasks/taskTypes';
import {
  openTelegramChannel,
  telegramShareInviteMessage,
  telegramVibrate,
} from '@app/shared/utils/common';
import { TaskDialogMessageType } from '@app/shared/types/pages/tasks';
import { Page } from '@app/routes';

export const TASK_ICONS: Record<
  TaskKey,
  ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>
> = {
  addPandaToName: Signature,
  refLinkToBio: Link,
  fillAboutMe: IdCard,
  collectAllStones: Gem,
  help3CollectAllStones: Pickaxe,
  help3Level3: Handshake,
  invite3: User,
  invite10: Users,
  invite50: Users,
  premiumChannel: KeyRound,
  sonOfSunChannel: ArrowRightSquare,
  domPandChannel: ArrowRightSquare,
  pandoraChannel: ArrowRightSquare,
};

interface TaskActionConfig {
  navigateAction?: (navigate?: (to: string) => void) => void;
  shareAction?: (userId: number, message: string) => void;
  messageType?: TaskDialogMessageType;
}

export const TASK_ACTION: Record<TaskKey, TaskActionConfig> = {
  addPandaToName: { messageType: 'help-name' },
  refLinkToBio: { messageType: 'help-ref' },
  fillAboutMe: {
    navigateAction: (navigate) => {
      telegramVibrate();
      navigate?.(Page.EDIT_PROFILE);
    },
  },
  collectAllStones: {
    navigateAction: (navigate) => {
      telegramVibrate();
      navigate?.(Page.COGNITION);
    },
  },
  help3CollectAllStones: {
    shareAction: (userId, message) => {
      telegramShareInviteMessage(userId, message);
    },
  },
  help3Level3: {
    shareAction: (userId, message) => {
      telegramShareInviteMessage(userId, message);
    },
  },
  invite3: {
    shareAction: (userId, message) => {
      telegramShareInviteMessage(userId, message);
    },
  },
  invite10: {
    shareAction: (userId, message) => {
      telegramShareInviteMessage(userId, message);
    },
  },
  invite50: {
    shareAction: (userId, message) => {
      telegramShareInviteMessage(userId, message);
    },
  },
  premiumChannel: {
    messageType: 'secret-room',
  },
  sonOfSunChannel: {
    navigateAction: () => {
      openTelegramChannel('son_of_sun22');
    },
  },
  domPandChannel: {
    navigateAction: () => {
      openTelegramChannel('dom_pand');
    },
  },
  pandoraChannel: {
    navigateAction: () => {
      openTelegramChannel('dom_pandora');
    },
  },
};
